import React, { memo, useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AlertDialog, DialogFooterProps, DialogHeaderProps } from '@lyearn/molecules';
import useNavigation from '@/hooks/useNavigation';

export interface DiscardChangesDialogProps {
  onClose: () => void;
  onDiscard?: () => void;
  header?: Partial<DialogHeaderProps>;
  variant?: 'create' | 'edit';
  footer?: Partial<DialogFooterProps>;
}

function DiscardChangesDialog({
  onClose,
  onDiscard,
  header,
  variant,
  footer,
}: DiscardChangesDialogProps) {
  const { t } = useTranslation();
  const navigation = useNavigation();

  const onClick = useCallback(() => {
    onDiscard ? onDiscard() : navigation.back();
  }, [navigation, onDiscard]);

  return (
    <AlertDialog
      header={{
        title: header?.title ?? t('Common:DiscardChangesTitle'),
        description: header?.description ?? t('Common:DiscardChangesDescription'),
      }}
      primaryAction={{
        appearance: variant === 'create' ? 'primary' : 'danger',
        label: variant === 'create' ? t('Common:Actions.GoBack') : t('Common:Actions.Discard'),
        onClick,
      }}
      secondaryAction={{
        label:
          footer?.secondaryAction?.label ??
          (variant === 'create' ? t('Common:Actions.Cancel') : t('Common:Actions.ContinueEditing')),
      }}
      onClose={onClose}
    />
  );
}

export default memo(DiscardChangesDialog);
